import React from 'react';
import ReactDOMServer from 'react-dom/server';

interface Props {
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  postcode?: string | null;
  organizationName?: string | null;
  icon?: React.ReactNode;
  hasLineBreak?: boolean;
}

const isNotEmpty = (str?: string | null) => str && str.length > 0;

const FormattedAddress = ({
  addressLine1,
  addressLine2,
  city,
  state,
  country,
  postcode,
  organizationName,
  icon,
  hasLineBreak = true,
}: Props) => {
  const formatCityStateAndZip = () => {
    if (city && state) {
      return postcode ? `${city}, ${state} ${postcode}` : `${city}, ${state}`;
    }

    return [city, state, postcode].filter(isNotEmpty).join(' ');
  };

  const formattedCityStateAndZip = formatCityStateAndZip();

  const addressLines = [organizationName, addressLine1, addressLine2, formattedCityStateAndZip, country]
    .filter(isNotEmpty)
    .map((addressLine, idx, addressLines) => (
      <React.Fragment key={idx}>
        {addressLine}
        {hasLineBreak && idx < addressLines.length - 1 && <br />}
        {!hasLineBreak && idx < addressLines.length - 1 && ', '}
      </React.Fragment>
    ));

  const addressTitle = addressLines
    .map((addressElement) => ReactDOMServer.renderToStaticMarkup(addressElement).replace(/<br\/>/, ' \n'))
    .join('');

  return (
    <>
      <span title={addressTitle}>{addressLines}</span>
      {icon}
    </>
  );
};

export default FormattedAddress;
